/**
 * Lijst met alle allergenen + icoontjes
 *
 */
const allergenen = {
  ei: {
    label: "Ei",
    text: "Allergie voor kippenei komt voor bij 2% van alle kleine kinderen. Op 4-jarige leeftijd zijn de meeste kinderen over hun kippenei-allergie heengegroeid. Minder dan 1% van alle volwassenen blijft allergisch voor kippenei. Eieren kunnen verwerkt zijn in heel veel soorten levensmiddelen.",
    nonText: "Vrij van ei", //TODO
    icon_amber_50: "eggs_amber_50x50.png",
    icon_grey_50: "eggs_grey_50x50.png",
    icon_red_50: "eggs_red_50x50.png",
    icon_sushito_50: "eggs_sushito_50x50.png",
    icon_amber_100: "eggs_amber_100x100.png",
    icon_grey_100: "eggs_grey_100x100.png",
    icon_red_100: "eggs_red_100x100.png",
    icon_sushito_100: "eggs_sushito_100x100.png",
    icon_amber_200: "eggs_amber_200x200.png",
    icon_grey_200: "eggs_grey_200x200.png",
    icon_red_200: "eggs_red_200x200.png",
    icon_sushito_200: "eggs_sushito_200x200.png",
  },
  schaal: {
    label: "Schaaldieren",
    text: "De groep schaaldieren omvat krab, garnalen en (rivier)kreeft. Wie allergisch reageert op schaaldieren, reageert ook vaak op weekdieren. Ongeveer 1% van de bevolking heeft een allergie voor vis of schaaldieren. Schaaldierallergie komt vrij vaak voor, het meest voor bij volwassenen. En vooral in regio’s waar veel schaaldieren worden gegeten. Na pinda’s en noten is het de meest voorkomende oorzaak van anafylaxie. Wie eenmaal een schaaldierallergie heeft, groeit er waarschijnlijk niet meer overheen.",
    nonText: "Vrij van schaaldieren", //TODO
    icon_amber_50: "crustacena_amber_50x50.png",
    icon_grey_50: "crustacena_grey_50x50.png",
    icon_red_50: "crustacena_red_50x50.png",
    icon_sushito_50: "crustacena_sushito_50x50.png",
    icon_amber_100: "crustacena_amber_100x100.png",
    icon_grey_100: "crustacena_grey_100x100.png",
    icon_red_100: "crustacena_red_100x100.png",
    icon_sushito_100: "crustacena_sushito_100x100.png",
    icon_amber_200: "crustacena_amber_200x200.png",
    icon_grey_200: "crustacena_grey_200x200.png",
    icon_red_200: "crustacena_red_200x200.png",
    icon_sushito_200: "crustacena_sushito_200x200.png",
  },
  gluten: {
    label: "Gluten",
    text: "Glutenbevattende granen, zoals tarwe (waaronder spelt en khorasantarwe, voorheen kamut), rogge, gerst en haver.",
    nonText: "Vrij van gluten", //TODO
    icon_amber_50: "wheat_amber_50x50.png",
    icon_grey_50: "wheat_grey_50x50.png",
    icon_red_50: "wheat_red_50x50.png",
    icon_sushito_50: "wheat_sushito_50x50.png",
    icon_amber_100: "wheat_amber_100x100.png",
    icon_grey_100: "wheat_grey_100x100.png",
    icon_red_100: "wheat_red_100x100.png",
    icon_sushito_100: "wheat_sushito_100x100.png",
    icon_amber_200: "wheat_amber_200x200.png",
    icon_grey_200: "wheat_grey_200x200.png",
    icon_red_200: "wheat_red_200x200.png",
    icon_sushito_200: "wheat_sushito_200x200.png",
  },
  vis: {
    label: "Vis",
    text: "Vis is waardevolle voeding. Want het bevat veel eiwitten en vette vis bevat ook gunstige vetten en vetoplosbare vitamines. Toch is het een van de meest voorkomende oorzaken van voedselallergie. Het allergene eiwit in vis is zeer hittestabiel. Dat betekent dat het eiwit allergeen blijft, ook na koken of bakken. Ongeveer 0,1 tot 0,2% van de kinderen en volwassenen heeft een visallergie. Visallergie komt vaker voor in landen waar men veel vis eet. Meestal groeit iemand met visallergie er niet overheen.",
    nonText: "Vrij van vis", //TODO
    icon_amber_50: "fish_amber_50x50.png",
    icon_grey_50: "fish_grey_50x50.png",
    icon_red_50: "fish_red_50x50.png",
    icon_sushito_50: "fish_sushito_50x50.png",
    icon_amber_100: "fish_amber_100x100.png",
    icon_grey_100: "fish_grey_100x100.png",
    icon_red_100: "fish_red_100x100.png",
    icon_sushito_100: "fish_sushito_100x100.png",
    icon_amber_200: "fish_amber_200x200.png",
    icon_grey_200: "fish_grey_200x200.png",
    icon_red_200: "fish_red_200x200.png",
    icon_sushito_200: "fish_sushito_200x200.png",
  },
  pinda: {
    label: "Pinda",
    text: "Pinda heet ook wel aardnoot, grondnoot, olienoot of apennoot. Eigenlijk is de pinda vanuit botanisch oogpunt geen noot. De pinda is een peulvrucht en behoort tot de bonen (vlinderbloemigen). Zoals alle zaden is pinda rijk aan eiwitten. Deze eiwitten zijn nodig voor de groei van de nieuwe plant. Behalve gewone pinda wordt ook de olie uit de pinda, arachideolie, gegeten. Versgeperste oliën zoals wokolie bevatten pinda-allergenen. Sterk verhitte olien, meestal gebruikt door de voedingsindustrie (zeker in medicijnen), zijn veilig.",
    nonText: "Vrij van pinda's", //TODO
    icon_amber_50: "peanut_amber_50x50.png",
    icon_grey_50: "peanut_grey_50x50.png",
    icon_red_50: "peanut_red_50x50.png",
    icon_sushito_50: "peanut_sushito_50x50.png",
    icon_amber_100: "peanut_amber_100x100.png",
    icon_grey_100: "peanut_grey_100x100.png",
    icon_red_100: "peanut_red_100x100.png",
    icon_sushito_100: "peanut_sushito_100x100.png",
    icon_amber_200: "peanut_amber_200x200.png",
    icon_grey_200: "peanut_grey_200x200.png",
    icon_red_200: "peanut_red_200x200.png",
    icon_sushito_200: "peanut_sushito_200x200.png",
  },
  soja: {
    label: "Soja",
    text: "Soja behoort tot de peulvruchten en is een van de belangrijkste voedselallergenen. Sojabonen zijn rijk aan goed bruikbare eiwitten. Gedroogde sojabonen bevatten ongeveer 35% eiwit. Daarmee is het een goede en goedkope vleesvervanger. Soja wordt veel gebruikt in de voedingsmiddelenindustrie als structuurverbeteraar, sojalecithine als emulgator en ‘eiwitvuller’. Verder zijn er nog afgeleiden zoals sojaolie, sojameel en sojaconcentraat.",
    nonText: "Vrij van Soja", //TODO
    icon_amber_50: "soya_amber_50x50.png",
    icon_grey_50: "soya_grey_50x50.png",
    icon_red_50: "soya_red_50x50.png",
    icon_sushito_50: "soya_sushito_50x50.png",
    icon_amber_100: "soya_amber_100x100.png",
    icon_grey_100: "soya_grey_100x100.png",
    icon_red_100: "soya_red_100x100.png",
    icon_sushito_100: "soya_sushito_100x100.png",
    icon_amber_200: "soya_amber_200x200.png",
    icon_grey_200: "soya_grey_200x200.png",
    icon_red_200: "soya_red_200x200.png",
    icon_sushito_200: "soya_sushito_200x200.png",
  },
  melk: {
    label: "Melk",
    text: "Melk, inclusief lactose",
    nonText: "Vrij van melk", //TODO
    icon_amber_50: "milk_amber_50x50.png",
    icon_grey_50: "milk_grey_50x50.png",
    icon_red_50: "milk_red_50x50.png",
    icon_sushito_50: "milk_sushito_50x50.png",
    icon_amber_100: "milk_amber_100x100.png",
    icon_grey_100: "milk_grey_100x100.png",
    icon_red_100: "milk_red_100x100.png",
    icon_sushito_100: "milk_sushito_100x100.png",
    icon_amber_200: "milk_amber_200x200.png",
    icon_grey_200: "milk_grey_200x200.png",
    icon_red_200: "milk_red_200x200.png",
    icon_sushito_200: "milk_sushito_200x200.png",
  },
  mosterd: {
    label: "Mosterd",
    text: "Mosterd heeft als belangrijkste ingrediënt mosterdzaden. Er zijn verschillende typen mosterdzaden: witte/ gele, bruine en zwarte mosterd. Mosterdzaad wordt veel gebruikt in smaakmakers en sauzen en kan als verborgen ingrediënt ernstige allergische reacties veroorzaken. Zeker in fastfoodrestaurants is het erg oppassen geblazen, omdat mosterd onbedoeld in een gerecht kan zitten. In Nederland is mosterdallergie redelijk zeldzaam, maar in Frankrijk komt het vaak voor.",
    nonText: "Vrij van mosterd", //TODO
    icon_amber_50: "mustard_amber_50x50.png",
    icon_grey_50: "mustard_grey_50x50.png",
    icon_red_50: "mustard_red_50x50.png",
    icon_sushito_50: "mustard_sushito_50x50.png",
    icon_amber_100: "mustard_amber_100x100.png",
    icon_grey_100: "mustard_grey_100x100.png",
    icon_red_100: "mustard_red_100x100.png",
    icon_sushito_100: "mustard_sushito_100x100.png",
    icon_amber_200: "mustard_amber_200x200.png",
    icon_grey_200: "mustard_grey_200x200.png",
    icon_red_200: "mustard_red_200x200.png",
    icon_sushito_200: "mustard_sushito_200x200.png",
  },
  noten: {
    label: "noten",
    text: "Noten, zoals amandelen, hazelnoten, walnoten, cashewnoten, pecannoten, paranoten, pistachenoten en macadamianoten",
    nonText: "Vrij van noten", //TODO
    icon_amber_50: "treenut_amber_50x50.png",
    icon_grey_50: "treenut_grey_50x50.png",
    icon_red_50: "treenut_red_50x50.png",
    icon_sushito_50: "treenut_sushito_50x50.png",
    icon_amber_100: "treenut_amber_100x100.png",
    icon_grey_100: "treenut_grey_100x100.png",
    icon_red_100: "treenut_red_100x100.png",
    icon_sushito_100: "treenut_sushito_100x100.png",
    icon_amber_200: "treenut_amber_200x200.png",
    icon_grey_200: "treenut_grey_200x200.png",
    icon_red_200: "treenut_red_200x200.png",
    icon_sushito_200: "treenut_sushito_200x200.png",
  },
  sesamzaad: {
    label: "Sesamzaad",
    text: "Sesamzaad wordt als hele zaadjes gegeten, bijvoorbeeld ter versiering van brood. De zaadjes bestaan voor ongeveer 50-60% uit olie. Ook wordt sesampasta en sesamolie uit de zaadjes gemaakt. Vooral in de afgelopen jaren is de consumptie sterk toegenomen.",
    nonText: "Vrij van sesamzaad", //TODO
    icon_amber_50: "sesame_amber_50x50.png",
    icon_grey_50: "sesame_grey_50x50.png",
    icon_red_50: "sesame_red_50x50.png",
    icon_sushito_50: "sesame_sushito_50x50.png",
    icon_amber_100: "sesame_amber_100x100.png",
    icon_grey_100: "sesame_grey_100x100.png",
    icon_red_100: "sesame_red_100x100.png",
    icon_sushito_100: "sesame_sushito_100x100.png",
    icon_amber_200: "sesame_amber_200x200.png",
    icon_grey_200: "sesame_grey_200x200.png",
    icon_red_200: "sesame_red_200x200.png",
    icon_sushito_200: "sesame_sushito_200x200.png",
  },
  zwaveldioxide: {
    label: "Zwaveldioxide",
    text: "Sulfiet komt van nature in bepaalde producten voor, maar het kan ook aan levensmiddelen worden toegevoegd als conserveermiddel (E220 – E228). Het zorgt ervoor dat vlees en fruit niet bruin kleurt. Vooral in gedroogd fruit, wijn en mosselen kunnen hoge sulfietgehalten voorkomen. Sulfiet geeft géén allergische reactie, maar een intolerantiereactie. Sulfiet kan bij hiervoor gevoelige mensen een astma-aanval veroorzaken. Sulfiet vind je ook veel in salades.",
    nonText: "Vrij van zwaveldioxide", //TODO
    icon_amber_50: "su;phurdioxide_amber_50x50.png",
    icon_grey_50: "su;phurdioxide_grey_50x50.png",
    icon_red_50: "su;phurdioxide_red_50x50.png",
    icon_sushito_50: "su;phurdioxide_sushito_50x50.png",
    icon_amber_100: "su;phurdioxide_amber_100x100.png",
    icon_grey_100: "su;phurdioxide_grey_100x100.png",
    icon_red_100: "su;phurdioxide_red_100x100.png",
    icon_sushito_100: "su;phurdioxide_sushito_100x100.png",
    icon_amber_200: "su;phurdioxide_amber_200x200.png",
    icon_grey_200: "su;phurdioxide_grey_200x200.png",
    icon_red_200: "su;phurdioxide_red_200x200.png",
    icon_sushito_200: "su;phurdioxide_sushito_200x200.png",
  },
  lupine: {
    label: "Lupine",
    text: "Lupinemeel wordt gemaakt van zaden van de blauwe lupine. Het heet ook wel ‘bonenmeel’. De voedingsmiddelenindustrie ziet lupinemeel als goed alternatief voor sojameel, dat vaak afkomstig is van genetisch gewijzigde soja. Lupine lijkt qua voedingsmiddel het meest op pinda’s. Het wordt de laatste jaren vaak gebruikt in voedingsmiddelen omdat het een goedkoop product is. Overgevoeligheid voor lupinemeel komt waarschijnlijk steeds vaker voor bij Nederlanders.",
    nonText: "Vrij van Lupine", //TODO
    icon_amber_50: "lupin_amber_50x50.png",
    icon_grey_50: "lupin_grey_50x50.png",
    icon_red_50: "lupin_red_50x50.png",
    icon_sushito_50: "lupin_sushito_50x50.png",
    icon_amber_100: "lupin_amber_100x100.png",
    icon_grey_100: "lupin_grey_100x100.png",
    icon_red_100: "lupin_red_100x100.png",
    icon_sushito_100: "lupin_sushito_100x100.png",
    icon_amber_200: "lupin_amber_200x200.png",
    icon_grey_200: "lupin_grey_200x200.png",
    icon_red_200: "lupin_red_200x200.png",
    icon_sushito_200: "lupin_sushito_200x200.png",
  },
  weekdieren: {
    label: "Weekdieren",
    text: "Weekdieren zijn mosselen, oesters, inktvissen en slakken. Wie allergisch reageert op weekdieren, reageert ook vaak op schaaldieren.",
    nonText: "Vrij van weekdieren", //TODO
    icon_amber_50: "molluscs_amber_50x50.png",
    icon_grey_50: "molluscs_grey_50x50.png",
    icon_red_50: "molluscs_red_50x50.png",
    icon_sushito_50: "molluscs_sushito_50x50.png",
    icon_amber_100: "molluscs_amber_100x100.png",
    icon_grey_100: "molluscs_grey_100x100.png",
    icon_red_100: "molluscs_red_100x100.png",
    icon_sushito_100: "molluscs_sushito_100x100.png",
    icon_amber_200: "molluscs_amber_200x200.png",
    icon_grey_200: "molluscs_grey_200x200.png",
    icon_red_200: "molluscs_red_200x200.png",
    icon_sushito_200: "molluscs_sushito_200x200.png",
  },
  selderij: {
    label: "Selderij",
    text: "Selderij kennen we als blad-, bleek- en knolselderij. Allergie voor selderij komt relatief veel voor bij mensen met voedselallergie. Sommigen reageren alleen op rauwe selderij, maar de meesten reageren ook op gekookte selderij. Het allergeen blijft stabiel na langdurige verhitting: meer dan 1 uur bij 100 graden. Selderij is een groente die deel uitmaakt van de schermbloemenfamilie. Het wordt zowel rauw als gekookt gegeten, of gedroogd  als specerij in kruidenmixen.",
    nonText: "Vrij van selderij", //TODO
    icon_amber_50: "celery_amber_50x50.png",
    icon_grey_50: "celery_grey_50x50.png",
    icon_red_50: "celery_red_50x50.png",
    icon_sushito_50: "celery_sushito_50x50.png",
    icon_amber_100: "celery_amber_100x100.png",
    icon_grey_100: "celery_grey_100x100.png",
    icon_red_100: "celery_red_100x100.png",
    icon_sushito_100: "celery_sushito_100x100.png",
    icon_amber_200: "celery_amber_200x200.png",
    icon_grey_200: "celery_grey_200x200.png",
    icon_red_200: "celery_red_200x200.png",
    icon_sushito_200: "celery_sushito_200x200.png",
  },
};

export default allergenen;
